import { useRef, useState } from "react";
import Overlay from "react-bootstrap/Overlay";

function InfoTooltip(props) {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  const text = props?.text;

  return (
    <>
      <span
        ref={target}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{ cursor: "pointer", display: "inline-block" }}
      >
        <span className="icon-info">
          <span className="sr-only" />
        </span>
      </span>
      <Overlay
        target={target.current}
        show={show}
        placement={props?.placement ?? "right"}
      >
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => (
          <div
            {...props}
            style={{
              position: "absolute",
              backgroundColor: "#555555",
              padding: "4px 10px",
              maxWidth: "200px",
              fontSize: "14px",
              color: "white",
              zIndex: "9999",
              borderRadius: 5,
              ...props.style,
            }}
          >
            <span>{text}</span>
          </div>
        )}
      </Overlay>
    </>
  );
}

export default InfoTooltip;
